import React from "react";
import {Button, CardActions, IconButton, Popover, Typography} from "@mui/material";
import InfoIcon from '@mui/icons-material/Info';
import {useTranslation} from "react-i18next";

const CardInfoButton = (props: any)=>{
    const {text, link,type} = props
    const {t} = useTranslation()
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);

    const handlePopoverClick = (event:any) => {
        setAnchorEl(event.currentTarget);
    };

    const handlePopoverClose = () => {
        setAnchorEl(null);
    };

    const id = open ? 'simple-popover' : undefined;
    return(
        <CardActions
            disableSpacing
            sx={{
                alignSelf: "stretch",
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "flex-start",
                // 👇 Edit padding to further adjust position
                p: 0,
            }}
        >

            <IconButton aria-label="delete" onClick={handlePopoverClick}>
                <InfoIcon />
            </IconButton>

            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handlePopoverClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
            >
                <Typography sx={{ p: 2 }}>{text}</Typography>
                <Button  style={{
                    alignSelf: "stretch",
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "flex-start",
                    p: 0,
                } as any}
                         variant="text"
                         onClick={()=> window.open(link+"?type="+ type,"_blank")}>
                    {t('info_page.see_more' as any)}
                </Button>
            </Popover>
        </CardActions>
    )
}
export default CardInfoButton
